(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.directive('userCaptionFilter', ['UserSearchPaginationService', 'HelperService', '$translate', UserCaptionFilterFn]);

    // filter directive for user view
    function UserCaptionFilterFn(UserSearchPaginationService, HelperService, $translate) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-caption-filter.template.html',
            scope: true
        };
        return directive;

        function link(scope) {

            // filter value
            scope.filterValue = null;
            scope.errorMessage = null;
            scope.searchClick = searchClick;
            scope.keypress = keypress;
            
            scope.refreshing = false;

            //activate directive
            activate();
            
            function keypress($event) {
                // if enter --> search
                if ($event.which === 13) {
                    searchClick();
                }
            }

            function searchClick() {
                // clear errormessage
                scope.errorMessage = '';
                if (scope.filterValue)
                {
                    if (HelperService.enoughCharactersForFilterCheck(scope.filterValue)) {
                        UserSearchPaginationService.data.pagination.searchFilter = scope.filterValue;
                        refresh();
                    }else{
                        scope.errorMessage = $translate.instant('Search_Input_Validation_Error');
                    }
                }else{
                    // if empty value, execute search without searchvalue
                    UserSearchPaginationService.data.pagination.searchFilter = scope.filterValue;
                    refresh();
                }
                
            }

            // refresh view no more than once per second
            function refresh() {
                if (!scope.refreshing) {
                    scope.refreshing = true;
                    // refresh overview
                    UserSearchPaginationService.search();
                    setTimeout(() => { scope.$apply(() =>  scope.refreshing = false); }, 1000);
                }
            } // refresh

            // init work
            function activate() {
                scope.errorMessage = '';
                scope.filterValue = UserSearchPaginationService.data.pagination.searchFilter;
                
            } //activate

        } // link
    }
})();